module.exports = __webpack_public_path__ + "static/media/escritura-procuracao.db3d6af2.jpg";